import { makeObservable, observable, action } from 'mobx';

class StoreData {
  constructor() {
    makeObservable(this, {
      newsList: observable,
      bigPackProduct: observable,
      setNewsList: action,
      selectCartList: observable,
      keywords: observable,
    });
  }
  newsList = [];
  selectCartList = [];
  bigPackProduct = {};
  keywords = '';
  setNewsList(data: any) {
    this.newsList = data;
  }
  setBigPack(data: any) {
    this.bigPackProduct = data;
  }
  setSelectCart(data: any) {
    this.selectCartList = data;
  }
  setKeyWords(data: any) {
    this.keywords = data;
  }
}

export default new StoreData();
